"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGetActivityByKey;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useGetActivityByKey() {
  return (0, _useContext.default)().getActivityByKey;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VHZXRBY3Rpdml0eUJ5S2V5IiwidXNlQWN0aXZpdHlLZXllckNvbnRleHQiLCJnZXRBY3Rpdml0eUJ5S2V5Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcHJvdmlkZXJzL0FjdGl2aXR5S2V5ZXIvdXNlR2V0QWN0aXZpdHlCeUtleS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFdlYkNoYXRBY3Rpdml0eSB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWNvcmUnO1xuXG5pbXBvcnQgdXNlQWN0aXZpdHlLZXllckNvbnRleHQgZnJvbSAnLi9wcml2YXRlL3VzZUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VHZXRBY3Rpdml0eUJ5S2V5KCk6IChrZXk/OiBzdHJpbmcpID0+IHVuZGVmaW5lZCB8IFdlYkNoYXRBY3Rpdml0eSB7XG4gIHJldHVybiB1c2VBY3Rpdml0eUtleWVyQ29udGV4dCgpLmdldEFjdGl2aXR5QnlLZXk7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFQTs7OztBQUVlLFNBQVNBLG1CQUFULEdBQThFO0VBQzNGLE9BQU8sSUFBQUMsbUJBQUEsSUFBMEJDLGdCQUFqQztBQUNEIn0=